export const truncateFilename = (filename: string, maxLength = 30): string => {
  if (!filename.includes('.')) {
    if (filename.length <= maxLength) return filename
    return `${filename.substring(0, maxLength - 3)}...`
  }

  const lastDotIndex = filename.lastIndexOf('.')
  const extension = filename.substring(lastDotIndex)
  const name = filename.substring(0, lastDotIndex)

  if (filename.length <= maxLength) return filename

  const availableLength = maxLength - extension.length - 3 // 3 は "..." の長さ

  if (availableLength <= 0) {
    return extension
  }

  return `${name.substring(0, availableLength)}...${extension}`
}
